import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { API_URL } from "../../../setup/config/env";
import { Box, CircularProgress, Typography } from "@mui/material";

const OAuthCallbackHandler = () => {
    const navigate = useHistory();

    useEffect(() => {
        const checkForCodeAndHandleOAuth = async () => {
            const params = new URLSearchParams(window.location.search);
            const code = params.get("code");
            const isOutlook = window.location.pathname.includes('outlook');
            const apiUrl = isOutlook
                ? `${API_URL}/api/calendar/outlook/oauth2callback`
                : `${API_URL}/api/calendar/oauth2callback`;

            if (code) {
                try {
                    const user = JSON.parse(localStorage.getItem('user')) || {};
                    const token = user.token || "";
                    const stateParam = params.get("state");
                    let stateData = {};
                    try {
                        if (stateParam) stateData = JSON.parse(stateParam);
                    } catch (e) {}

                    const consultationTypeId = stateData.consultationTypeId || sessionStorage.getItem('oauth_consultation_type_id') || "";
                    const consultationTypeIndex = stateData.consultationTypeIndex !== undefined ? stateData.consultationTypeIndex : (sessionStorage.getItem('oauth_consultation_type_index') || 0);
                    const calendarEmail = stateData.calendarEmail || sessionStorage.getItem('oauth_calendar_email') || "";

                    const response = await fetch(
                        apiUrl,
                        {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                "Authentication": `Bearer ${token}`
                            },
                            body: JSON.stringify({
                                code,
                                consultationTypeId,
                                consultationTypeIndex,
                                calendarEmail,
                                state: stateParam
                            }),
                        }
                    );
                    sessionStorage.removeItem('oauth_consultation_type_id');
                    sessionStorage.removeItem('oauth_consultation_type_index');
                    sessionStorage.removeItem('oauth_calendar_email');
                    if (response.status === 200) navigate.push("/calendar")
                    if (!response.ok) throw new Error("Failed to authorize");
                } catch (error) {
                    console.error("Authorization failed:", error);
                    sessionStorage.removeItem('oauth_consultation_type_id');
                    sessionStorage.removeItem('oauth_consultation_type_index');
                    sessionStorage.removeItem('oauth_calendar_email');
                    alert("Authorization failed. Please try again.");
                    navigate.push("/");
                }
            } else {
                navigate.push("/");
            }
        };

        checkForCodeAndHandleOAuth();
    }, [navigate]);

    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="100vh"
        >
            <Box textAlign="center">
                <Typography variant="h5" component="h1" gutterBottom>
                    Authorizing...
                </Typography>
                <CircularProgress />
                <Typography variant="body1" sx={{ mt: 2 }}>
                    Please wait while we authorize your account.
                </Typography>
            </Box>
        </Box>
    );
};

export default OAuthCallbackHandler;
